var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import './OffsetPaginator.scss';
import { LoadingSpinner } from './LoadingSpinner';
import { When } from 'react-if';
import { useOnMount, useSonarShallowSelector } from '@hooks';
import { Pagination } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
export const OffsetPaginator = (_a) => {
    var _b, _c;
    var { children, loading, render, request, selector, offset = 0, count = 10 } = _a, rest = __rest(_a, ["children", "loading", "render", "request", "selector", "offset", "count"]);
    const [current, setCurrent] = useState(1);
    const data = useSonarShallowSelector(selector);
    const showPagination = ((_b = data === null || data === void 0 ? void 0 : data.totalCount) !== null && _b !== void 0 ? _b : 0) > ((_c = data === null || data === void 0 ? void 0 : data.results.length) !== null && _c !== void 0 ? _c : 0);
    useOnMount(() => {
        request({
            count,
            offset
        });
    });
    useEffect(() => {
        setCurrent(offset && count ? Math.floor(offset / count) + 1 : 1);
    }, [offset, count]);
    const handleOnChange = useCallback((page, pageSize) => {
        setCurrent(page);
        request({
            count: pageSize,
            offset: (page - 1) * pageSize
        });
    }, [request]);
    return (React.createElement(React.Fragment, null,
        React.createElement(LoadingSpinner, { spinning: loading || !data }, render ? render(data) : children),
        React.createElement(When, { condition: showPagination },
            React.createElement(Pagination, Object.assign({ current: current, onChange: handleOnChange, pageSize: count, showSizeChanger: false, total: data === null || data === void 0 ? void 0 : data.totalCount }, rest)))));
};
